import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import axios from "axios";
import Cookies from "js-cookie";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {BlockUI} from "primereact/blockui";

import FormLocker from "../../util/FormLocker";
import moment from "moment/moment";
import {Calendar} from "primereact/calendar";
import {addLocale} from "primereact/api";
import {InputMask} from "primereact/inputmask";
import {InputSwitch} from "primereact/inputswitch";
import {InputNumber} from "primereact/inputnumber";
import {InputTextarea} from "primereact/inputtextarea";
import HelpComponent from "../HelpComponent";

const SubscriptionplanFormComponent = (props) => {

  const {t} = props;
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const normalizeAmount = (value) => {
    if (value === undefined || value === null) {
      return value;
    }

    return String(value).split('.')[0];
  };

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const normalizedFormData = {
      ...formData,
      amount: normalizeAmount(formData.amount),
      paused_amount: normalizeAmount(formData.paused_amount)
    };
    const normalizedNewFormData = {
      ...newFormData,
      ...(Object.prototype.hasOwnProperty.call(newFormData, 'amount')
        ? {amount: normalizeAmount(newFormData.amount)}
        : {}),
      ...(Object.prototype.hasOwnProperty.call(newFormData, 'paused_amount')
        ? {paused_amount: normalizeAmount(newFormData.paused_amount)}
        : {})
    };
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/subscription-plan/" + formData.id,
        normalizedNewFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData({
            ...response.data.data,
            amount: normalizeAmount(response.data.data.amount),
            paused_amount: normalizeAmount(response.data.data.paused_amount)
          });
          setNewFormData({});
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderSubscriptionplanList: true,
          })
          if (props.closeForm === true) {
            window.App.setState({
              sidebarSubscriptionplanForm: false,
            })
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/subscription-plan",
        normalizedFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData({
            ...response.data.data,
            amount: normalizeAmount(response.data.data.amount),
            paused_amount: normalizeAmount(response.data.data.paused_amount)
          })
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderSubscriptionplanList: true,
          })
          if (props.closeForm === true) {
            window.App.setState({
              sidebarSubscriptionplanForm: false,
            })
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  useEffect(() => {
    if (window.App.state.propsSubscriptionplan && window.App.state.propsSubscriptionplan.id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/subscription-plan/" + window.App.state.propsSubscriptionplan.id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData({
            ...response.data.data,
            amount: normalizeAmount(response.data.data.amount),
            paused_amount: normalizeAmount(response.data.data.paused_amount)
          });
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('registrations_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({...formData, name: e.target.value});
                                   setNewFormData({...newFormData, name: e.target.value});
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="amount" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"amount"}/>
                      <label htmlFor="amount"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('net_amount')}</label>
                      <span className="p-d-block">
                      <InputText id="amount" {...input}
                                 keyfilter={"int"}
                                 onChange={(e) => {
                                   const normalizedAmount = normalizeAmount(e.target.value);
                                   setFormData({
                                     ...formData,
                                     amount: normalizedAmount
                                   })
                                   setNewFormData({...newFormData, amount: normalizedAmount});
                                 }}
                                 value={formData.amount}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="paused_amount" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"paused_amount"}/>
                      <label htmlFor="amount"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('paused_amount')}</label>
                      <span className="p-d-block">
                      <InputText id="paused_amount" {...input}
                                 keyfilter={"int"}
                                 onChange={(e) => {
                                   const normalizedAmount = normalizeAmount(e.target.value);
                                   setFormData({
                                     ...formData,
                                     paused_amount: normalizedAmount
                                   })
                                   setNewFormData({...newFormData, paused_amount: normalizedAmount});
                                 }}
                                 value={formData.paused_amount}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-12"}>
                  <Field name="public_description" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="public_description"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('description')}</label>
                      <InputTextarea id="public_description" {...input}
                                 rows={6}
                                 autoResize
                                 onChange={(e) => {
                                   setFormData({...formData, public_description: e.target.value});
                                   setNewFormData({...newFormData, public_description: e.target.value});
                                 }}
                                 value={formData.public_description}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="visible_for_plan_list" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"visible_for_plan_list"}/>
                      <label htmlFor="visible_for_plan_list"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('visible_for_plan_list')}</label>
                      <span className="p-d-block">
                      <InputSwitch
                        className={"p-mt-1"}
                        name={"visible_for_plan_list"}
                        value={formData.visible_for_plan_list}
                        checked={formData.visible_for_plan_list}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            visible_for_plan_list: e.value
                          })
                          setNewFormData({
                            ...newFormData,
                            visible_for_plan_list: e.value
                          })
                        }}/>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(SubscriptionplanFormComponent);
